import { VFC } from 'react';
import { SensorScanStepFooter } from './steps/sensor_scan/Footer';
import { SensorConnectionStepFooter } from './steps/sensor_connection_check/Footer';
import { InstallMeterDetailStepFooter } from './steps/installation_detail/Footer';
import { PhotoStepFooter } from './steps/photo/Footer';
import { ReviewStepFooter } from './steps/review/Footer';
import { NotFoundFooter } from '../not_found/components/NotFoundFooter';
import { HardwaresStepFooter } from './steps/hardwares/Footer';
import { InstallationTechnologyStepFooter } from './steps/installation_technology/Footer';
import { InstallMeterStep } from './enums/installMeterStep';

const MAP = {
  [InstallMeterStep.InstallationTechnology]: InstallationTechnologyStepFooter,
  [InstallMeterStep.SensorScan]: SensorScanStepFooter,
  [InstallMeterStep.SensorConnection]: SensorConnectionStepFooter,
  [InstallMeterStep.Hardwares]: HardwaresStepFooter,
  [InstallMeterStep.InstallationDetail]: InstallMeterDetailStepFooter,
  [InstallMeterStep.Photo]: PhotoStepFooter,
  [InstallMeterStep.Review]: ReviewStepFooter,
} satisfies Record<InstallMeterStep, VFC>;

export const getFooterByStep = (newStep: InstallMeterStep): VFC => MAP[newStep] ?? NotFoundFooter;
